import { atom } from "recoil";

export const companyState = atom<any>({
  key: "companyState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (initial state)
});
